import { render } from "./Register.vue?vue&type=template&id=79f3409e&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=79f3409e&scoped=true&lang=scss"
import "./Register.vue?vue&type=style&index=1&id=79f3409e&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f3409e"]])

export default __exports__